import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import apiClientPlatform from '@/apiClientPlatform'
import type {
  PlatformRegistrationBlocksListResponse,
  PlatformRevokeRegistrationBlockResponse,
} from '@/types/platform'

export const registrationBlocksKey = (
  params: { take?: number; cursor?: string | null } = {}
) => ['platformRegistrationBlocks', params] as const

export const useRegistrationBlocksQuery = (params?: {
  take?: number
  cursor?: string | null
}) => {
  return useQuery({
    queryKey: registrationBlocksKey(params ?? {}),
    queryFn: async () => {
      const { data } =
        await apiClientPlatform.get<PlatformRegistrationBlocksListResponse>(
          `/platform/registration-blocks`,
          { params: { take: params?.take, cursor: params?.cursor ?? undefined } }
        )
      return data
    },
    placeholderData: keepPreviousData,
  })
}

export const useRevokeRegistrationBlockMutation = (blockId: string) => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const { data } =
        await apiClientPlatform.patch<PlatformRevokeRegistrationBlockResponse>(
          `/platform/registration-blocks/${blockId}/revoke`
        )
      return data
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['platformRegistrationBlocks'] })
      await qc.invalidateQueries({ queryKey: ['platformAudit'] })
    },
  })
}
